import { FC } from 'react';
import { createInvestmentSales } from '../../../fetch/imports';
import { UploadHandler } from '../../../components/import/uploadHandler';

const templateUrl = `${process.env.PUBLIC_URL}/templates/IVS_Activity_Import_Template.xlsx`;

// Downloadable Word document guide bundled with the app (public/templates).
const documentationUrl = `${process.env.PUBLIC_URL}/templates/IVS_Bulk_Import_Documentation.docx`;

export const ImportInvestmentSales: FC = () => {
  return (
    <UploadHandler
      title='Import Legacy Investment Sales Activities'
      loaderMessage='Importing Legacy Investment Sales Activities ...'
      createEndpoint={createInvestmentSales}
      templateDownloadUrl={templateUrl}
      documentationUrl={documentationUrl}
    />
  );
};
